import { Controller } from "@hotwired/stimulus"

// Wraps a <select> with a searchable text input + dropdown
export default class extends Controller {
  static targets = ["select", "input", "dropdown"]

  connect() {
    this.options = Array.from(this.selectTarget.options)
      .filter(o => o.value)
      .map(o => ({ value: o.value, label: o.textContent }))
    this.selectedIndex = -1
    this.open = false
  }

  disconnect() {
    this.close()
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    const matches = query.length
      ? this.options.filter(o => o.label.toLowerCase().includes(query))
      : this.options

    this.renderDropdown(matches)
    this.show()
  }

  renderDropdown(items) {
    const el = this.dropdownTarget
    el.textContent = ""
    this.selectedIndex = -1

    if (!items.length) {
      const empty = document.createElement("div")
      empty.className = "px-3 py-2 text-sm text-muted"
      empty.textContent = "Aucun résultat"
      el.appendChild(empty)
      return
    }

    items.forEach((item, i) => {
      const div = document.createElement("div")
      div.className = "px-3 py-2 text-sm cursor-pointer hover:bg-emerald-600/20 min-h-[44px] flex items-center"
      div.textContent = item.label
      div.dataset.value = item.value
      div.dataset.index = i
      div.addEventListener("click", () => this.pick(item))
      el.appendChild(div)
    })
  }

  pick(item) {
    this.selectTarget.value = item.value
    this.inputTarget.value = item.label
    this.close()
    this.selectTarget.dispatchEvent(new Event("change"))
  }

  show() {
    this.dropdownTarget.classList.remove("hidden")
    this.open = true
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    this.open = false
    this.selectedIndex = -1
  }

  onKeydown(event) {
    if (!this.open) {
      if (event.key === "ArrowDown") { this.filter(); return }
      return
    }
    const items = this.dropdownTarget.children
    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1)
      this.highlightItem(items)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
      this.highlightItem(items)
    } else if (event.key === "Enter") {
      event.preventDefault()
      if (this.selectedIndex >= 0 && items[this.selectedIndex]?.dataset?.value) {
        const val = items[this.selectedIndex].dataset.value
        const match = this.options.find(o => o.value === val)
        if (match) this.pick(match)
      }
    } else if (event.key === "Escape") {
      this.close()
    }
  }

  highlightItem(items) {
    Array.from(items).forEach((el, i) => {
      el.classList.toggle("bg-emerald-600/20", i === this.selectedIndex)
    })
    items[this.selectedIndex]?.scrollIntoView({ block: "nearest" })
  }

  onBlur() {
    // Delay to allow click on dropdown items
    setTimeout(() => this.close(), 200)
  }
}
